import React from 'react'
import styles from './button.module.css'
import { Link } from 'gatsby'

export default ({ children, to, ariaLabel }) => (
  <Link className={styles.button} to={to} aria-label={ariaLabel}>
    {children}
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9619 0C15.3761 1.49012e-08 15.7119 0.335786 15.7119 0.75C15.7122 4.07166 18.4004 6.76538 21.7197 6.77539H22.9668C22.9928 6.77539 23.0186 6.77671 23.0439 6.7793L23.1182 6.79102C23.1669 6.80101 23.214 6.81505 23.2588 6.83398C23.3035 6.85289 23.3459 6.87648 23.3857 6.90332C23.5056 6.98423 23.6012 7.09869 23.6582 7.2334C23.6962 7.32308 23.7167 7.42188 23.7168 7.52539C23.7166 7.93944 23.3809 8.27637 22.9668 8.27637H21.7383C21.7321 8.27637 21.7259 8.27541 21.7197 8.27539C18.4002 8.2854 15.7119 10.9799 15.7119 14.3018C15.7119 14.716 15.3761 15.0518 14.9619 15.0518C14.5478 15.0516 14.2119 14.7159 14.2119 14.3018C14.2119 11.8365 15.3976 9.64823 17.2295 8.27539H0.75C0.335787 8.27539 5.96046e-08 7.9396 0 7.52539C1.40071e-06 7.11118 0.335788 6.77539 0.75 6.77539H17.2295C15.3978 5.40263 14.2121 3.21495 14.2119 0.75C14.2119 0.335866 14.5478 0.000128895 14.9619 0Z"
        fill="white"
      />
    </svg>
  </Link>
)
